<script setup lang="ts">
import t from "~/utils/translate";
import { useSettings } from "~/store/settings";
import { IOutcome, IStrikeResponse } from "~/types/racing/jackpot-bets";
import { useBetslip } from "~/store/betslip";
import { IJackpotEvent } from "./Selections.vue";

interface IConfirmationModalProps {
	active: boolean;
	betsAndResponse: { response: IStrikeResponse; betsOutcomes: IOutcome[] };
	events: IJackpotEvent[];
}

const props = defineProps<IConfirmationModalProps>();
const emits = defineEmits(["set-active", "handle-close"]);

const submissionResponse = computed(() => props.betsAndResponse.response);
const addToBetslip = () => {
	const betslip = useBetslip();
	const selections = props.betsAndResponse.betsOutcomes.map((s) => {
		const market = props.events.flatMap((m) => m.markets).find((c) => c.market.marketId.marketId === +s.marketId)?.market;
		return {
			event: props.events.find((v) => v.event.eventId === s.eventId)?.event,
			market: { ...market, marketId: String(market?.marketId.marketId) },
			outcome: s,
			price: s.price,
			score: null,
		};
	});
	if (selections) {
		// @ts-ignore There are values in the horse emop which arent in rest of sport.
		betslip.handleMultipleSelections(selections);
		emits("handle-close");
	}
};
</script>

<template>
	<UiModal
		:size="'small'"
		:active="active"
		@set-active="(val: boolean) => emits('set-active', val)"
		:title="t('jackpot-confirmation')"
		:content-padding="false"
	>
		<div v-if="!submissionResponse.isSuccessful" class="my-2">
			<div class="flex flex-col w-full justify-center items-center">
				<span class="text-l font-bold text-warning-600 text-center p-2">{{ t("jackpot-submission-failed") }} </span>
				<div v-if="submissionResponse?.error" class="text-xs leading-4 font-bold">
					{{ submissionResponse.error }}
				</div>
			</div>
			<div class="bg-light-50 dark:bg-dark-900 flex justify-center mt-3">
				<UiButton :label="t('close')" :size="'medium'" class="my-2 mx-2 w-full" @click="emits('handle-close')" />
			</div>
		</div>

		<div v-else class="my-2">
			<div class="flex flex-col w-full justify-center items-center">
				<span class="text-l font-bold text-primary-700 text-center p-2">{{ t("jackpot-submitted-successfully") }} </span>
			</div>
			<div class="bg-light-50 dark:bg-dark-900 flex justify-center mt-3">
				<UiButton :label="t('done')" :size="'medium'" class="my-2 mx-2 w-full" @click="emits('handle-close')" />
				<UiButton :label="t('add-to-betslip')" variant="secondary" :size="'medium'" class="my-2 mx-2 w-full" @click="addToBetslip()" />
			</div>
		</div>
	</UiModal>
</template>
